import Requester from "./helpers/Requester_v2";

const alfredoAPIRequesterV2 = new Requester(
  `${process.env.REACT_APP_SERVER_V2}`
);

export { alfredoAPIRequesterV2 };
